// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getProductList } from "../services/productService";

const useProductList = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  const fetchProductList = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductList(req);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setTotal(response.total ?? 0); // assuming total is part of the response
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchProductList,
    data,
    total,
    status,
    error,
    resetStatus,
  };
};

export default useProductList;
